/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Evento { 
    id?: string;
    tipo?: EventoTipoEnum;
    stato_da?: EventoStatoDaEnum;
    stato_a?: EventoStatoAEnum;
    esito?: EventoEsitoEnum;
    nota?: string;
    autore_tipo?: EventoAutoreTipoEnum;
    autore?: string;
    created_at?: string;
}
export enum EventoTipoEnum {
    CREATA = 'CREATA',
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    NOTA = 'NOTA',
    CHIUSA = 'CHIUSA'
};
export enum EventoStatoDaEnum {
    APERTA = 'APERTA',
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    CHIUSA = 'CHIUSA'
};
export enum EventoStatoAEnum {
    APERTA = 'APERTA',
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    CHIUSA = 'CHIUSA'
};
export enum EventoEsitoEnum {
    ACCOUNT_ABUSIVO_ANONIMIZZATO = 'ACCOUNT_ABUSIVO_ANONIMIZZATO',
    NESSUN_ABUSO = 'NESSUN_ABUSO',
    RITIRATA_DAL_SEGNALANTE = 'RITIRATA_DAL_SEGNALANTE',
    ALTRO = 'ALTRO'
};
export enum EventoAutoreTipoEnum {
    SEGNALANTE = 'SEGNALANTE',
    OPERATORE = 'OPERATORE'
};



